export const MISSING_CAPTURE_SESSION_MESSAGE =
  "Unable to initialize payment: Missing capture session.";

type CaptureSessionLike = {
  clientSecret?: string;
  processor?: string;
  cardRequestToken?: string;
  cardUrl?: string;
};

export function isUsableCaptureSession(
  session?: CaptureSessionLike | null,
): boolean {
  if (session?.clientSecret) {
    return true;
  }

  return Boolean(
    session?.processor === "dimepay" &&
      session.cardRequestToken &&
      session.cardUrl,
  );
}
